// Static map for child/detail routes that are not in menuConfig.
// Each entry: { prefix, crumbs[] }
// crumbs items: { type, key?, label, route? }
//   type "module"    → opens that module panel in sidebar (needs key)
//   type "submodule" → opens that submodule accordion (needs key)
//   type "page"      → current/leaf page (no key, no click)
const CHILD_ROUTE_MAP = [
  {
    prefix: "/organizationtype",
    crumbs: [
      { type: "module",    key: "module-2", label: "Account" },
      { type: "submodule", key: "sub-20",   label: "Branding & Personalization" },
      { type: "page",      label: "Organizations", route: "/organization" },
      { type: "page",                        label: "Organization Type" },
    ],
  },
  {
    prefix: "/lot_items/",
    crumbs: [
      { type: "module",    key: "module-7", label: "Fulfillment" },
      { type: "submodule", key: "sub-72",   label: "Fulfillment Center" },
      { type: "page",                        label: "Lot Inspection" },
    ],
  },
  {
    prefix: "/reverse_lot_items/",
    crumbs: [
      { type: "module",    key: "module-7", label: "Fulfillment" },
      { type: "submodule", key: "sub-72",   label: "Fulfillment Center" },
      { type: "page",                        label: "Reverse Lot Inspection" },
    ],
  },
  {
    prefix: "/order_variants/",
    crumbs: [
      { type: "module",    key: "module-7", label: "Fulfillment" },
      { type: "submodule", key: "sub-70",   label: "Instant Fulfillment" },
      { type: "page",                        label: "Order Variants" },
    ],
  },
  {
    prefix: "/Order/promoOrderItems/",
    crumbs: [
      { type: "module",    key: "module-7", label: "Fulfillment" },
      { type: "submodule", key: "sub-70",   label: "Instant Fulfillment" },
      { type: "page",                        label: "Promo Order Items" },
    ],
  },
  {
    prefix: "/Order/editOrder/",
    crumbs: [
      { type: "module",    key: "module-7", label: "Fulfillment" },
      { type: "submodule", key: "sub-70",   label: "Instant Fulfillment" },
      { type: "page",                        label: "Edit Order" },
    ],
  },
  {
    prefix: "/admin_customer/vieworder/",
    crumbs: [
      { type: "page", label: "Customer" },
      { type: "page", label: "View Orders" },
    ],
  },
  {
    prefix: "/admin_customer/vieworderitem/",
    crumbs: [
      { type: "page", label: "Customer" },
      { type: "page", label: "View Order Items" },
    ],
  },
];

// The route itself or a child of it ("/product" matches "/product/add",
// not "/product_variant")
const routeMatches = (pathname, route) =>
  pathname === route || pathname.startsWith(route.replace(/\/$/, "") + "/");

export const findBreadcrumbPath = (modules, pathname) => {
  // ── 1. Search menu config (registered pages) — most specific route wins
  let best = null;
  const consider = (route, build) => {
    if (route && routeMatches(pathname, route) && (!best || route.length > best.route.length)) {
      best = { route, build };
    }
  };

  for (const module of modules) {
    // Direct Pages
    for (const page of (module.directPages || [])) {
      if (!page.isActive) continue;
      consider(page.route, () => {
        const items = [
          { type: "module", key: `module-${module.id}`, label: module.name },
        ];
        if (page.name !== module.name) {
          items.push({ type: "page", label: page.name, route: page.route });
        }
        return items;
      });
    }

    // Submodules
    for (const sub of (module.submodules || [])) {
      for (const page of (sub.pages || [])) {
        if (!page.isActive) continue;
        consider(page.route, () => {
          const items = [
            { type: "module", key: `module-${module.id}`, label: module.name },
          ];
          if (sub.name !== module.name) {
            items.push({ type: "submodule", key: `sub-${sub.id}`, label: sub.name });
          }
          const prevLabel = items[items.length - 1].label;
          if (page.name !== prevLabel) {
            items.push({ type: "page", label: page.name, route: page.route });
          }
          return items;
        });
      }
    }
  }
  if (best) return best.build();

  // ── 2. Fall back to child route map (detail/action pages) ─────
  for (const entry of CHILD_ROUTE_MAP) {
    if (pathname.startsWith(entry.prefix)) {
      return entry.crumbs;
    }
  }

  return [];
};
